module.exports = __webpack_public_path__ + "static/media/glasschain-logo.32884356.png";